import React from 'react';
import { SearchProvider } from "v4/contexts/SearchContext/SearchContext";
import SearchSectionContent from "./SearchSectionContent";

export default function SearchSection({
                                          searchText,
                                          resultsText,
                                          rowActions,
                                          searchRouteName,
                                          tableClassName,
                                          route,
                                      }) {
    const { search_type: entity, } = route;

    return (
        <SearchProvider searchRouteName={searchRouteName}
                        pageType={`search-${entity}`}
                        overrideRoute={route}
                        shouldBypassForm
        >
            <SearchSectionContent
                entity={entity}
                title={route.label}
                resultsText={resultsText}
                searchText={searchText}
                rowActions={rowActions}
                tableClassName={tableClassName}
            />
        </SearchProvider>
    );
}
